"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlusIcon = exports.PlusCircleIcon = exports.MinusCircleIcon = exports.LogoIcon = exports.CloseIcon = exports.BackgroundIcon = exports.ArrowRightIcon = exports.ArrowLeftIcon = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "null",
    d: "M11.265 26.93l22.003 22.002c.509.51 1.188.79 1.913.79s1.403-.28 1.912-.79l1.62-1.62a2.708 2.708 0 0 0 0-3.825L20.238 25.01 38.734 6.513c.51-.51.79-1.188.79-1.912 0-.725-.28-1.404-.79-1.914l-1.62-1.62c-.51-.508-1.189-.79-1.913-.79s-1.404.281-1.913.79L11.265 23.092a2.69 2.69 0 0 0-.789 1.918c-.002.728.278 1.41.789 1.92z"
  }));
};

exports.ArrowLeftIcon = ArrowLeftIcon;
ArrowLeftIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "null",
    d: "M38.735 23.07L16.732 1.069c-.509-.51-1.188-.79-1.913-.79s-1.403.28-1.912.79l-1.62 1.62a2.708 2.708 0 0 0 0 3.825L29.762 24.99 11.266 43.487a2.687 2.687 0 0 0-.79 1.912c0 .725.28 1.404.79 1.914l1.62 1.62c.51.509 1.188.79 1.913.79s1.404-.281 1.912-.79l22.024-22.024c.51-.51.79-1.193.789-1.918a2.688 2.688 0 0 0-.789-1.92z"
  }));
};

exports.ArrowRightIcon = ArrowRightIcon;
ArrowRightIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
};

var BackgroundIcon = function BackgroundIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.938 19H313v165.652H3.937zm0 0"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 47h53v137.652H24zm0 0"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M38 141h12v43.652H38zm0 0"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M308 19h95v165.652h-95zm0 0"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M94 6.738h402.106v177.914H94zm0 0"
  }))), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M638.807 287h87.303v66.307h-87.303zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M622.29 274.398h120.316v91.403H622.29zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M638.807 452.496h87.194v173.912h-87.303V452.496zm43.597-99.189V287",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M622.29 440.003h120.316V639.79H622.29zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M832.994 452.496h87.216v173.912h-87.216zm-150.59 173.912V452.496",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M816.39 440.003h120.403V639.79H816.39zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M638.807 732.408h87.194v173.89h-87.303v-173.89zm237.784-106V452.496",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M622.29 719.893h120.316v199.81H622.29zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M832.994 732.408h87.216v173.89h-87.216zm-150.59 173.89v-173.89",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M816.39 719.893h120.403v199.81H816.39zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1093.207 452.496h87.194v173.912H1093.1V452.496zM876.591 906.298v-173.89",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1076.69 440.003h120.316V639.79H1076.69zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1353.507 452.496h87.194v173.912h-87.303V452.496zm-216.616 173.912V452.496",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1336.99 440.003h120.315V639.79H1336.99zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1548.694 452.496h87.216v173.912h-87.303V452.496zm-151.59 173.912V452.496",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1532.198 440.003h120.294V639.79h-120.294zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1353.507 731.996h87.194v173.912h-87.303V731.996zm238.784-105.588V452.496",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1336.99 719.394h120.315v199.81H1336.99zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1548.694 731.996h87.216v173.912h-87.303V731.996zm-151.59 173.803V731.996",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1532.198 719.394h120.294v199.81h-120.294zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M832.994 287h87.216v66.307h-87.216zm759.297 618.8V731.995",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M816.39 274.398h120.403v91.403H816.39zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1093.207 287h87.194v66.307H1093.1V287zm-216.616 66.307V287",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1076.69 274.398h120.316v91.403H1076.69zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1353.507 287h87.194v66.307h-87.303V287zm-216.616 66.307V287",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1336.99 274.398h120.315v91.403H1336.99zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1548.694 287h87.216v66.307h-87.303V287zm-151.59 66.307V287",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M1532.198 274.398h120.294v91.403h-120.294zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1204.808 977.507h-64.005v-217.9h64.005zm-64.113 0h-64.005v-217.9h64.005zm64.113-217.9H1076.69v-39.714h128.118zm22.19 217.9H1054.5v-280.91h172.497zM286.01 111.093L26.602 181.196h514.905zm242.283 92.704h-488.5l-13.192-22.601h514.906zm0 816.613h-488.5V203.797h488.5zm1203.7-.716h-1203.7V203.71h1203.7zM1592.29 353.307V287",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M349.21 443.907c-12.213-23.1-36.402-38.804-64.417-38.804-28.1 0-52.399 15.9-64.591 39.194m-8.107 172.698v18.61H357.6v-18.61",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M341.995 788.607v231.803m-52.79-231.803v231.803m-80.804 0h-69.699V788.607h69.699zm215.203 0h-69.699V788.607h69.699zm-91.91-703.304c0-25.898-20.995-46.807-46.792-46.807-25.906 0-46.792 20.996-46.792 46.807zm22.211 471.501c0-40.213-32.6-72.814-72.806-72.814s-72.807 32.6-72.807 72.814zm23.603-3.514c0-53.184-43.098-96.39-96.41-96.39-53.29 0-96.408 43.098-96.408 96.39",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "4.659",
    d: "M289.205 969.807h52.79m-52.79-36.31h52.79m-52.79-36.2h52.79m-52.79-36.201h52.79m-52.79-36.201h52.79m-26.406-36.288v181.2",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M273.21 788.607v231.803m-52.9-231.803v231.803",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "4.659",
    d: "M220.31 969.807h52.79m-52.79-36.31h52.79m-52.79-36.2h52.79m-52.79-36.201h52.79m-52.79-36.201h52.79m-26.405-36.288v181.2",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M334.606 479.197c0-27.395-22.211-49.692-49.704-49.692-27.406 0-49.704 22.189-49.704 49.692v137.798h99.3V479.197zm-149.112-49.692c27.405 0 49.704 22.189 49.704 49.692v137.798h-49.704zm198.707 0c-27.405 0-49.704 22.189-49.704 49.692v137.798h49.704zM281.207 788.607l51.4-51.405m-51.4 51.405l-51.399-51.405m51.4 51.405v-72.814",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "4.659",
    d: "M72.807 930.2H39.794v-32.99h33.013zm19.799-33.099H39.794v-32.99h52.812zm-19.8-32.99H39.795v-33.013h33.013zm19.8-33.013H39.794v-32.99h52.812zm-19.8-32.99H39.795v-33.013h33.013zm19.8-33.013H39.794v-32.99h52.812zm-19.8-32.99H39.795v-33.013h33.013zm19.8-33.1H39.794v-33.012h52.812zm-19.8-33.012H39.795v-32.991h33.013zm19.8-32.991H39.794V599.99h52.812zm-19.8-33.012H39.795v-32.991h33.013zm19.8-32.991H39.794v-32.991h52.812zm-19.8-32.991H39.795v-33.012h33.013zm19.8-33.012H39.794v-32.991h52.812zm-19.8-33.1H39.795v-32.99h33.013zm19.8-32.99H39.794v-33.013h52.812zm-19.8-33.013H39.795v-32.99h33.013zm19.8-32.99H39.794V335.89h52.812zm-19.8-99.103H39.795v-32.99h33.013zm19.8-32.99H39.794v-33.013h52.812zm-19.8 99.08H39.795V302.9h33.013zm19.8-32.99H39.794v-32.991h52.812zm435.687 627.3h-32.99v-32.99h32.99zm0-33.099h-52.79v-32.99h52.79zm0-32.99h-32.99v-33.013h32.99zm0-33.013h-52.79v-32.99h52.79zm0-32.99h-32.99v-33.013h32.99zm0-33.013h-52.79v-32.99h52.79zm0-32.99h-32.99v-33.013h32.99zm0-33.1h-52.79v-33.012h52.79zm0-33.012h-32.99v-32.991h32.99zm0-32.991h-52.79v-33.013h52.79zm0-33.013h-32.99V567h32.99zm0-32.99h-52.79v-32.991h52.79zm0-32.991h-32.99v-33.012h32.99zm0-33.012h-52.79v-32.991h52.79zm0-33.1h-32.99v-32.99h32.99zm0-32.99h-52.79v-33.013h52.79zm0-33.013h-32.99v-32.99h32.99zm0-32.99h-52.79V335.89h52.79zm0-99.103h-32.99v-32.99h32.99zm0-32.99h-52.79v-33.013h52.79zm0 99.08h-32.99V302.9h32.99zm0-32.99h-52.79v-32.992h52.79zM284.902 429.504v187.49m-48.509-48.5h99.3m-99.3-45.202h99.408m-100.603-44.096h99.408",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M2023.893 316.39c0-25.897-20.995-46.785-46.792-46.785s-46.792 20.996-46.792 46.786zm-45.597-205.99l-259.387 70.103h514.884zm242.196 92.704h-488.5l-13.191-22.601h514.905zm0 816.591h-488.5V203.103h488.5zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "4.659",
    d: "M1765.092 929.507h-32.99v-33.013h32.99zm19.8-33.1h-52.9v-33.012h52.813v33.012zm-19.8-33.012h-32.99v-32.99h32.99zm19.8-32.99h-52.9v-33.013h52.813v33.012zm-19.8-33.013h-32.99V764.4h32.99zm19.8-32.991h-52.9v-32.99h52.813v32.99zm-19.8-32.99h-32.99v-33.013h32.99zm19.8-33.122h-52.9V665.3h52.813v32.99zm-19.8-32.99h-32.99v-32.991h32.99zm19.8-32.991h-52.9v-33.013h52.813v33.013zm-19.8-33.013h-32.99v-32.99h32.99zm19.8-32.99h-52.9v-33.013h52.813v33.013zm-19.8-33.013h-32.99v-32.99h32.99zm19.8-32.99h-52.9V467.31h52.813v32.99zm-19.8-33.1h-32.99V434.19h32.99zm19.8-33.012h-52.9v-32.991h52.813v32.991zm-19.8-32.99h-32.99v-32.992h32.99zm19.8-32.992h-52.9v-33.012h52.813v33.012zm-19.8-99.015h-32.99v-32.991h32.99zm19.8-33.1h-52.9v-32.99h52.813v32.99zm-19.8 99.103h-32.99v-32.99h32.99zm19.8-32.99h-52.9v-33.013h52.813v33.012zm435.6 627.3h-32.99v-33.012h32.99zm0-33.099h-52.79v-33.012h52.79zm0-33.012h-32.99v-32.99h32.99zm0-32.99h-52.79v-33.013h52.79zm0-33.013h-32.99V764.4h32.99zm0-32.991h-52.79v-32.99h52.79zm0-32.99h-32.99v-33.013h32.99zm0-33.122h-52.79V665.3h52.79zm0-32.99h-32.99v-32.991h32.99zm0-32.991h-52.79v-33.013h52.79zm0-33.013h-32.99v-32.99h32.99zm0-32.99h-52.79v-33.013h52.79zm0-33.013h-32.99v-32.99h32.99zm0-32.99h-52.79V467.31h52.79zm0-33.1h-32.99V434.19h32.99zm0-33.012h-52.79v-32.991h52.79zm0-32.99h-32.99v-32.992h32.99zm0-32.992h-52.79v-33.012h52.79zm0-99.015h-32.99v-32.991h32.99zm0-33.1h-52.79v-32.99h52.79zm0 99.103h-32.99v-32.99h32.99zm0-32.99h-52.79v-33.013h52.79zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M2034.194 788.607v231.803m-52.79-231.803v231.803m-10.997 0h-69.699V788.607h69.7zm145.483 0h-69.699V788.607h69.699zm-69.786-231.803c0-40.213-32.6-72.814-72.806-72.814s-72.807 32.6-72.807 72.814zm23.69-3.514c0-53.184-43.098-96.39-96.388-96.39-53.311 0-96.409 43.098-96.409 96.39v235.317m-582.496-.716H986.192V998.59h308.418v21.104zm-21.907-21.104h-264.386v-21.083h264.386zm408.304-896.086h-34.6l17.3-24.402zm0 0h-34.6v70.19h34.6zM622.29 169.396h-34.6V66.195h34.6zm-34.6-10.194l-59.397 44.508h1203.7l-51.095-38.305m-34.6-26.006l-48.9-36.591H662.91l-40.619 30.387m0-67h-34.6l17.3-24.402zm1944.501 670.312h-10.802v-10.801c0-5.314-4.28-9.5-9.497-9.5-5.281 0-9.497 4.294-9.497 9.5v10.801h-10.802c-5.303 0-9.497 4.295-9.497 9.5 0 5.293 4.303 9.501 9.497 9.501h10.802v10.802c0 5.292 4.303 9.5 9.497 9.5 5.303 0 9.497-4.316 9.497-9.5v-10.802h10.802c5.303 0 9.52-4.316 9.52-9.5 0-5.314-4.304-9.5-9.52-9.5zm-346.299-56.61h535.118L2454.19 549.69h-233.698zm0 312.403h496.91V679.896h-496.91zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "4.659",
    d: "M1981.404 969.807h52.79m-52.79-36.31h52.79m-52.79-36.2h52.79m-52.79-36.201h52.79m-52.79-36.201h52.79m-26.384-36.288v181.2",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M1973.406 788.607l51.4-51.405m-51.4 51.405l-51.399-51.405m51.4 51.405v-72.814",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3.494",
    d: "M2041.497 443.907c-12.193-23.1-36.404-38.804-64.396-38.804-28.101 0-52.399 15.9-64.591 39.194m-8.107 172.698v18.61h145.505v-18.61",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "9.318",
    d: "M2026.805 479.197c0-27.395-22.211-49.692-49.704-49.692-27.406 0-49.704 22.189-49.704 49.692v137.798h99.3V479.197zm-149.004-49.692c27.406 0 49.705 22.189 49.705 49.692v137.798H1877.8zm198.708 0c-27.406 0-49.704 22.189-49.704 49.692v137.798h49.704zm0 0",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "#c3d2da",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "4.659",
    d: "M2049.908 315.61c0-40.214-32.6-72.814-72.807-72.814s-72.807 32.6-72.807 72.814v21.885H2049.8V315.61zm-1692.308.694c0-40.214-32.6-72.814-72.807-72.814-40.185 0-72.785 32.6-72.785 72.814v21.885h145.483v-21.885zm1619.5 113.2v187.49m-48.508-48.499H2028m-99.408-45.202H2028m-100.603-44.096h99.408",
    transform: "matrix(.17974 0 0 .1801 0 .055)"
  }));
};

exports.BackgroundIcon = BackgroundIcon;
BackgroundIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 499 192"
};

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.46 49.5L25 28.71 6.54 49.5 3 45.96 21.64 25 3 4.04 6.54.5 25 21.29 43.46.5 47 4.04 28.28 25 47 45.96l-3.54 3.54"
  }));
};

exports.CloseIcon = CloseIcon;
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
};

var LogoIcon = function LogoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    d: "M-1-1h402v52H-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M72.505 9.51c8.94 0 13.47 4.74 13.47 4.74l-1.4 1.72s-4.47-4.26-12.02-4.26c-9.27 0-16.33 7.27-16.33 17.03 0 9.81 7 17.57 16.49 17.57 8.08 0 12.77-5.12 12.77-5.12l1.45 1.62s-5.07 5.71-14.23 5.71c-10.99 0-18.91-8.84-18.91-19.78.02-10.93 8.1-19.23 18.71-19.23zm20.37.65h2.32v17.72h23.93V10.16h2.31v37.71h-2.31V30.04h-23.93v17.83h-2.32V10.16zm38.16 0h20.63v2.15h-18.32v15.46h15.04v2.16h-15.04v15.79h19.35v2.15h-21.66V10.16zm24.84 0h2.48l11.37 30.5c.65 1.78 1.45 4.53 1.45 4.53h.11s.81-2.75 1.45-4.53l11.42-30.5h2.48l-14.12 37.72h-2.53l-14.11-37.72zm51.67 24.67h-16l-4.85 13.04h-2.48l14.12-37.72h2.48l14.12 37.72h-2.48l-4.91-13.04zm-8.02-21.98s-.81 2.91-1.4 4.53l-5.77 15.3h14.39l-5.71-15.3c-.59-1.62-1.4-4.53-1.4-4.53h-.11zm20.31-2.69h2.32v35.56h18v2.15h-20.32V10.16zm26.19 0h2.32v37.71h-2.32V10.16zm12.66 0h2.16l21.5 29.58c1.24 1.72 3.07 4.74 3.07 4.74h.11s-.27-2.86-.27-4.74V10.16h2.32v37.72h-2.16l-21.5-29.58c-1.24-1.72-3.07-4.74-3.07-4.74h-.11s.27 2.86.27 4.74v29.58h-2.32V10.16zm39.29 0h2.32v37.71h-2.32V10.16zm12.66 0h20.64v2.15h-18.32v15.46h15.03v2.15h-15.03v15.79h19.34v2.15h-21.66v-37.7zm5.55-8.68h3.02l3.61 5.98h-2.37l-4.26-5.98zm22.9 8.68h11.05c3.5 0 5.28.38 6.79 1.13 3.12 1.56 5.23 4.74 5.23 9.05 0 5.39-3.13 9.43-7.54 10.4v.11s.38.43.86 1.35l8.46 15.68h-2.75l-8.94-16.7h-10.83v16.7h-2.32V10.16h-.01zm12.56 18.85c4.96 0 8.08-3.56 8.08-8.68 0-3.34-1.67-6.04-4.42-7.27-1.08-.49-2.26-.76-5.28-.76h-8.62V29h10.24v.01zm19.51-18.85h20.63v2.15h-18.32v15.46h15.04v2.16h-15.04v15.79h19.35v2.15h-21.66V10.16zm-332.15 38.3l-4.06-10.78h-13.04l-1.37 3.68h-2.33l9.12-24.37h2.24l11.78 31.47h-2.34zm-4.83-12.85l-4.65-12.47c-.38-1.04-.87-2.73-1.07-3.43-.2.7-.69 2.4-1.07 3.43l-4.7 12.47h11.49z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.185 48.46V16.98h2.2v29.41h14.88v2.07H7.185z"
  }));
};

exports.LogoIcon = LogoIcon;
LogoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 400 50"
};

var MinusCircleIcon = function MinusCircleIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 49.952C11.24 49.952.048 38.759.048 25S11.241.048 25 .048 49.952 11.241 49.952 25 38.759 49.952 25 49.952zm0-46.785C12.96 3.167 3.167 12.961 3.167 25S12.961 46.833 25 46.833 46.833 37.039 46.833 25 37.039 3.167 25 3.167zm0 0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.916 26.56H14.084a1.56 1.56 0 0 1 0-3.12h21.832a1.56 1.56 0 0 1 0 3.12zm0 0"
  }));
};

exports.MinusCircleIcon = MinusCircleIcon;
MinusCircleIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
};

var PlusCircleIcon = function PlusCircleIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 49.917C11.26 49.917.083 38.74.083 25S11.26.083 25 .083 49.917 11.26 49.917 25 38.74 49.917 25 49.917zm0-46.72C12.978 3.199 3.198 12.978 3.198 25S12.978 46.802 25 46.802 46.802 37.022 46.802 25 37.022 3.198 25 3.198zm0 0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.901 26.557H14.099a1.558 1.558 0 0 1 0-3.114h21.802a1.558 1.558 0 0 1 0 3.114zm0 0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 37.458c-.86 0-1.557-.697-1.557-1.557V14.099a1.558 1.558 0 0 1 3.114 0v21.802c0 .86-.697 1.557-1.557 1.557zm0 0"
  }));
};

exports.PlusCircleIcon = PlusCircleIcon;
PlusCircleIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
};

var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 27.4h19.5v21.5h5.1V27.4H47v-4.8H27.6V1.1h-5.1v21.5H3z"
  }));
};

exports.PlusIcon = PlusIcon;
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
};